import {
    type GuidanceSession,
    type GuidanceSessionType,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface AdminCreateGuidanceSessionBody {
    membershipId: string;
    sessionType: GuidanceSessionType;
    startTimeUtc: string;
}

export const useCreateGuidanceSession = requestBuilder.mutation<
    GuidanceSession,
    AdminCreateGuidanceSessionBody
>({
    endpoint: '/api/admin/guidance-session',
    method: 'POST',
});
